// extracted by mini-css-extract-plugin
export default {"wrapper":"eA-z","viewport":"fA-z","container":"gA-z","slide":"hA-z"};